// Route configuration with SEO data
export const routes = [
  {
    path: "/",
    title: "Best Personalized Hair loss Treatment & Diagnosis",
    exact: true,
    desc: "Personalized hair loss treatment plans with expert diagnosis, hair care solutions, and effective hair growth management for lasting results.",
    keywords:
      "Take a Hair test, Hair Loss Treatment, Hair Care, Hair Treatments",
  },
  { 
    path: "/login", 
    title: "HairsNcares - Login",
    desc: "Login to your HairsNcares account to access personalized hair care solutions and track your treatment progress.",
    keywords: "HairsNcares login, hair care account, user login"
  },
  {
    path: "/best-hair-care-products-hair-loss-scalp-health",
    title: "Best Hair Care Products for Hair Loss & Scalp Health",
    desc: "Discover top hair care products for hair loss, dandruff, and thinning. Expert solutions for men, women, and all hair types, including curly and color-treated.",
    keywords: "hair care products, hair loss products, scalp health, hair treatment products"
  },
  { 
    path: "/book", 
    title: "HairsNcares - Book Appointment",
    desc: "Book an appointment with our hair care experts for personalized consultation and treatment plans.",
    keywords: "book appointment, hair consultation, hair expert appointment"
  },
  {
    path: "/about-us-quality-hair-loss-scalp-care",
    title: "About us - Hairsncares",
    desc: "At Hairsncares, we provide expert hair loss solutions, personalized treatments, and hair care designed to help you regain confidence and healthy growth.",
    keywords:
      "hair care experts, about HairsnCares, hair treatments, hair solutions, healthy hair, hair care professionals, hair care advice",
  },
  { 
    path: "/product-detail",
    title: "Product Details - HairsNcares",
    desc: "Detailed information about our hair care products with ingredients, usage instructions, and customer reviews.",
    keywords: "product details, hair product information, hair care ingredients"
  },
  {
    path: "/hair-loss-treatment-experts-dermatologists",
    title: "Find the Best Dermatologists in India | Skin & Hair Experts",
    desc: "Find the best dermatologists in India offering expert hair care, personalized treatments, and advanced solutions for lasting results",
    keywords: "dermatologists India, hair experts, skin hair specialists, hair treatment doctors"
  },
  { 
    path: "/our-expertise", 
    title: "HairsNcares - Our Expertise",
    desc: "Learn about our expertise in hair care, advanced treatments, and personalized solutions for various hair concerns.",
    keywords: "hair care expertise, hair treatment experience, professional hair care"
  },
  { 
    path: "/user-profile", 
    title: "HairsNcares - User Profile",
    desc: "Manage your profile, view treatment history, and track your hair care progress with HairsNcares.",
    keywords: "user profile, hair care profile, treatment history"
  },
  { 
    path: "/user-profile/", 
    title: "HairsNcares - User Profile",
    desc: "Manage your profile, view treatment history, and track your hair care progress with HairsNcares.",
    keywords: "user profile, hair care profile, treatment history"
  },
  {
    path: "/take-hair-test",
    title: "Hair Loss Test Online | Free Hair Diagnosis Test",
    desc: "Take a quick hair loss test online to know your hair condition. Get accurate results and personalized treatment recommendations with Hairs n Cares.",
    keywords: "hair test online, hair loss test, hair diagnosis, free hair assessment"
  },
  { 
    path: "/doctor/report", 
    title: "HairsNcares - Doctor Report",
    desc: "View detailed doctor reports and analysis of your hair condition and treatment progress.",
    keywords: "doctor report, hair analysis report, treatment progress"
  },
  {
    path: "/doctor-analyse-report",
    title: "HairsNcares - Doctor Analyse Report",
    desc: "Comprehensive analysis report from our hair care experts with detailed recommendations.",
    keywords: "doctor analysis, hair report analysis, expert recommendations"
  },
  { 
    path: "/address", 
    title: "HairsNcares - Address Management",
    desc: "Manage your addresses for product delivery and appointment scheduling with HairsNcares.",
    keywords: "address management, delivery address, appointment location"
  },
  { 
    path: "/management-report/", 
    title: "HairsNcares - Management Report",
    desc: "Administrative management reports for hair care treatment tracking and analysis.",
    keywords: "management report, treatment tracking, administrative reports"
  },
  { 
    path: "/my-orders", 
    title: "HairsNcares - My Orders",
    desc: "View and track your hair care product orders, delivery status, and order history.",
    keywords: "my orders, order tracking, hair product orders, order history"
  },
  { 
    path: "/create-order", 
    title: "HairsNcares - Create Order",
    desc: "Create new orders for hair care products and treatments with easy checkout process.",
    keywords: "create order, hair product purchase, place order"
  },
  { 
    path: "/cart", 
    title: "HairsNcares - Shopping Cart",
    desc: "Review your selected hair care products and proceed to checkout for your hair care needs.",
    keywords: "shopping cart, hair products cart, checkout"
  },
  {
    path: "/hair-care-blogs",
    title: "Hair Care Blogs | Expert Hair Tips & Hair Care Solutions",
    desc: "Hair Care Blogs with expert tips, personalized solutions, and hair growth advice for healthy, strong, and beautiful hair",
    exact: true,
    keywords: "hair care blogs, hair tips, hair care advice, hair growth tips"
  },
  {
    path: "/advanced-hair-loss-solutions-prp-smp-cloning-systems",
    title: "PRP Hair Treatment | Hair Cloning & Advanced Solutions",
    desc: "PRP hair treatment, advanced solutions, scalp micropigmentation, and hair cloning techniques for effective hair restoration",
    keywords: "PRP hair treatment, hair cloning, scalp micropigmentation, advanced hair solutions"
  },
  {
    path: "/hair-transplants-fue-dhi-mhi-natural-restoration",
    title: "Hair Transplant Methods | Advanced Hair Transplant Care",
    desc: "Best advanced hair transplant techniques and methods for natural hair growth, expert care, and personalized solutions to restore your confidence.",
    keywords: "hair transplant, FUE hair transplant, DHI hair transplant, hair restoration"
  },
  {
    path: "/online-hair-loss-test-diagnosis-treatment",
    title: "Online Hair Loss Treatment & Diagnosis | Hairs n Cares",
    desc: "Get expert hair loss diagnosis online. Take our test to identify causes and explore personalized online hair loss treatment options with Hairs n Cares.",
    keywords: "online hair loss treatment, hair loss diagnosis, online hair consultation"
  },
  {
    path: "/effective-hair-loss-treatment-men",
    title: "Best Hair Loss Solutions for Men | Personalized & Advanced Care",
    desc: "Best hair loss treatments for men with advanced care and customized hair care solutions to help you achieve stronger, healthier hair.",
    keywords:
      "hair loss treatment for men, male pattern baldness solutions, hair regrowth for men, Minoxidil for men, Finasteride hair loss, hair transplant options, laser therapy hair loss, causes of hair loss in men, scalp health, prevent hair loss men, online hair test, HairsnCares hair loss solutions",
  },
  {
    path: "/hair-loss-women-causes-treatments-remedies",
    title: "Women's Hair Loss Treatment | Causes & Hair Care Solutions",
    desc: "Hair loss treatments for women with expert diagnosis, natural care, and solutions designed to restore growth and improve hair health.",
    keywords: "women hair loss treatment, female hair loss, hair loss causes women, women hair care"
  },
  {
    path: "/dr-amit-agarkar-hair-restoration-expert",
    title: "Dr. Amit Agarkar | Hair Transplant & Restoration Expert",
    desc: "Meet Dr. Amit Agarkar, leading dermatologist and hair transplant surgeon in India. Renowned hair restoration expert offering advanced treatment solutions.",
    keywords: "Dr. Amit Agarkar, hair transplant surgeon, hair restoration expert, dermatologist India"
  },
  {
    path: "/contact-hair-experts",
    title: "Contact Us | Best Hair Loss Treatment & Solutions",
    desc: "Contact our experts for the best hair loss treatment, diagnosis, and growth solutions. We provide personalized care for your hair concerns.",
    keywords:
      "contact HairsnCares, hair care contact, hair loss expert contact, hair growth inquiries, hair treatment support, customer service, get in touch, contact for hair solutions, hair restoration queries",
  },
  {
    path: "/disclaimer",
    title: "Hairsncares Disclaimer - Legal & Usage Notice",
    desc: "Read the Hairsncares Disclaimer for legal, accuracy, and usage guidelines. Understand your rights and responsibilities when using our hair care content and services.",
    keywords: "HairsnCares disclaimer, legal notice, usage guidelines, terms disclaimer"
  },
  {
    path: "/policy",
    title: "Privacy Policy | Hair Treatment Policy & Data Safety",
    desc: "Read our Privacy Policy for hair treatment services. Learn how we protect your data, ensure safety, and maintain transparency in our policy.",
    keywords: "privacy policy, data protection, hair treatment policy, data safety"
  },
  {
    path: "/terms-of-service",
    title: "Terms of Service | Hair Treatment & Care Policies",
    desc: "Read our Terms of Service for hair treatment. Learn about policies, customer care, and guidelines for safe and effective hair care services",
    keywords: "terms of service, hair treatment terms, service policies, user agreements"
  },
  {
    path: "/return-policy",
    title: "Return & Refund Policy for Hair Treatment Products",
    desc: "Read our return & refund policy for hair treatment products. Hassle-free process to ensure customer satisfaction with every purchase",
    keywords: "return policy, refund policy, hair product returns, customer satisfaction"
  },
  {
    path: "/online-hair-loss-treatment-bangalore",
    title: "Online Hair Loss Treatment Bangalore | Personalized Care",
    desc: "Get online hair loss treatment in Bangalore with expert doctors, personalised plans and proven medicines to stop hair fall and regrow hair from home.",
    keywords: "hair loss treatment Bangalore, online hair treatment Bangalore, hair care Bangalore, hair fall treatment, dermatologist Bangalore, hair loss consultation online"
  },
  {
    path: "/online-hair-loss-treatment-delhi",
    title: "Online Hair Loss Treatment Delhi | Expert Care Online",
    desc: "Looking for online hair loss treatment in Delhi? Consult experienced doctors online and get personalized solutions for hair loss.",
    keywords: "hair loss treatment Delhi, online hair treatment Delhi, hair care Delhi, hair fall treatment, dermatologist Delhi, hair loss consultation online"
  },
  {
    path: "/online-hair-loss-treatment-chennai",
    title: "Online Hair Loss Treatment Chennai | Expert Care Online",
    desc: "Looking for online hair loss treatment in Chennai? Consult experienced doctors online and get personalized solutions for hair loss.",
    keywords: "hair loss treatment Chennai, online hair treatment Chennai, hair care Chennai, hair fall treatment, dermatologist Chennai, hair loss consultation online"
  },
  {
    path: "/online-hair-loss-treatment-hyderabad",
    title: "Online Hair Loss Treatment Hyderabad | Expert Care Online",
    desc: "Looking for online hair loss treatment in Hyderabad? Consult experienced doctors online and get personalized solutions for hair loss.",
    keywords: "hair loss treatment Hyderabad, online hair treatment Hyderabad, hair care Hyderabad, hair fall treatment, dermatologist Hyderabad, hair loss consultation online"
  }
];

// Function to get route data by path
export const getRouteData = (pathname) => {
  const route = routes.find((route) =>
    route.exact 
      ? route.path === pathname
      : pathname.startsWith(route.path)
  );
  
  return route || {
    title: "HairsNcares - Hair Care Solutions",
    desc: "Discover customized hair loss treatments and accurate diagnosis with Hairsncares. Our expert services and advanced hair tests provide personalized solutions for effective hair restoration.",
    keywords: "hair care, hair loss treatment, hair solutions, HairsNcares"
  };
};

export default {
  routes,
  getRouteData
};